import React from 'react';
//Custom
import loading from '../Assets/loading.svg';

export const Loading = () => (
  <div className='spinner'>
    <img src={loading} alt='Loading' width='20%' height='20%' />
  </div>
);
